/**
 * עיצוב תצוגת מחיר/סטטוס מחיר — בלי חישובי תמחור.
 *
 * @param {{ price?: { value?: number|null, currency?: string|null, type?: string } }} item
 * @param {{ currency?: string, locale?: string }} [options]
 * @returns {string}
 */
export function formatAttractionPrice(item, options = {}) {
  if (!item || typeof item !== "object") return "";
  const price = item.price;
  if (!price || typeof price !== "object") return "";

  const type = price.type || "unknown";

  if (type === "included") return "כלול";
  if (type === "gift") return "מתנה";

  const value = price.value;
  const currency = price.currency || options.currency || "ILS";
  const locale = options.locale || "he-IL";

  if (value != null && Number.isFinite(Number(value)) && Number(value) >= 0) {
    const sym = currency === "ILS" || currency === "ILS".toUpperCase() ? "₪" : currency;
    const n = Number(value);
    const formatted = Number.isInteger(n)
      ? n.toLocaleString(locale)
      : n.toLocaleString(locale, { maximumFractionDigits: 2 });
    return sym === "₪" ? `${formatted} ${sym}` : `${formatted} ${sym}`.trim();
  }

  return "";
}
